var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaging({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6514_4221",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6514_4221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 18.6667C8.76736 18.6667 7.53906 18.2604 6.52344 17.4479C5.50781 16.6354 5 15.6528 5 14.5C5 13.8333 5.18229 13.2118 5.54687 12.6354C5.91146 12.059 6.42361 11.5694 7.08333 11.1667V4.5C7.08333 3.80556 7.38715 3.21528 7.99479 2.72917C8.60243 2.24306 9.34028 2 10.2083 2C11.0764 2 11.8142 2.24306 12.4219 2.72917C13.0295 3.21528 13.3333 3.80556 13.3333 4.5V11.1667C13.9931 11.5694 14.5052 12.059 14.8698 12.6354C15.2344 13.2118 15.4167 13.8333 15.4167 14.5C15.4167 15.6528 14.9089 16.6354 13.8932 17.4479C12.8776 18.2604 11.6493 18.6667 10.2083 18.6667ZM9.16667 9.5H11.25V8.66667H10.2083V7.83333H11.25V6.16667H10.2083V5.33333H11.25V4.5C11.25 4.26389 11.1502 4.06597 10.9505 3.90625C10.7509 3.74653 10.5035 3.66667 10.2083 3.66667C9.91319 3.66667 9.6658 3.74653 9.46614 3.90625C9.26649 4.06597 9.16667 4.26389 9.16667 4.5V9.5Z",
    fill: "#135FC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaging);
export default __webpack_public_path__ + "static/media/Staging.6329e2fdbe4dc32a5c30af266521a0cf.svg";
export { ForwardRef as ReactComponent };